export default function(dsf,options) {
  return {
    id: "",
    name: "",
    code: "",
    type: dsf.metadata.mmtype(3),
    at: "",
    currentControl: null,
    controls: [],
    validate: dsf.metadata.validate(),
    defaultValue: null,
    valueAttributes: [
      {
        name: "开始日期",
        code: "stime",
        type: dsf.metadata.getDataType("time"),
        length: null,
        defaultValue: null,
        unit: null
      }, {
        name: "结束日期",
        code: "etime",
        type: dsf.metadata.getDataType("time"),
        length: null,
        defaultValue: null,
        unit: null,
        encrypt:false
      }
    ]
  };
}